export default __webpack_public_path__ + "static/media/truck_logo.54b3906e.png";